module.exports = __webpack_public_path__ + "img/thumbnail_EgyptianFruitBat_u_albino.63ae9144.png";